import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTriangleDownMedium"><Path d="M17.5 9.5H6.5L12 16L17.5 9.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
